module.exports = __webpack_public_path__ + "img/icon_NCDs_A04_bf.c7e58cc3.png";